var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legal-text-picker"
  }, [_c('form', {
    staticClass: "uk-search uk-search-default uk-margin-bottom",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirmSelection($event)
      }
    }
  }, [_c('span', {
    attrs: {
      "uk-search-icon": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "primaryInput",
    staticClass: "uk-search-input",
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "uk-grid-small",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('div', {
    staticClass: "legal-texts uk-height-medium",
    on: {
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.confirmSelection($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.selectPreviousLegalText($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.selectNextLegalText($event)
      }]
    }
  }, [(_vm.legalTexts.length) ? _c('ul', {
    staticClass: "uk-tab-right",
    attrs: {
      "uk-tab": ""
    }
  }, _vm._l((_vm.legalTexts), function(legalText, index) {
    return _c('li', {
      class: {
        'uk-active': _vm.selectedIndex === index
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.selectLegalText(index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(legalText.name) + "\n            ")])])
  })) : _c('div', [_vm._v("\n          " + _vm._s(_vm.$t('noResults')) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2 uk-grid-item-match"
  }, [_c('div', {
    staticClass: "uk-panel uk-panel-scrollable uk-background-muted\n                  uk-padding-small uk-height-medium"
  }, [(_vm.selected) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.selected.body)
    }
  }) : _vm._e()])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67bf84ee","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/LegalTextPicker.vue
// module id = 2028
// module chunks = 0